import { Component, ElementRef } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'INÍCIO'
  user = 'Lucas'

  isCollapsed = false;

  selectedItemIndex: number = -1;

  selectItem(index: number) {
    this.selectedItemIndex = index;
  }

  constructor(private elRef: ElementRef) { }

  onMenuClick(event: MouseEvent) {
    event.stopPropagation();
  }

}
